"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeToString = void 0;
const sizeToString = (value) => {
    if (!value) {
        return;
    }
    if (Number.isNaN(value)) {
        return;
    }
    if (Number.isInteger(value) || value >= 1) {
        return `${value}px`;
    }
    return `${value * 100}%`;
};
exports.sizeToString = sizeToString;
//# sourceMappingURL=sizeToString.js.map